<template>
    <v-container class="roma-bottom-nav d-block d-sm-none">
        <v-row no-gutters="">
            <slot></slot>
        </v-row>
    </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss">
.roma-bottom-nav {
    position: fixed;
    top: calc(100vh - 62px);
    left: 0%;
    background-color: #fff;
    height: 64px;
    width: 100%;
    z-index: 1;
}
.btn-text {
    font-size: 11px;
}
</style>
